/* Bellori — page Contact : pills de motif (préfixe le sujet + affiche/masque commande & miroir),
   bouton Copier l'e-mail, prénom conservé pour l'écran de confirmation, honeypot. */
(function () {
  'use strict';
  var root = document.querySelector('[data-contact]');
  if (!root) return;

  /* ---- Écran de confirmation : réinjecter le prénom mémorisé ---- */
  var confirm = root.querySelector('#contact-confirm');
  if (confirm) {
    var nameSlot = confirm.querySelector('[data-confirm-name]');
    try {
      var fn = sessionStorage.getItem('bellori_contact_name');
      if (fn && nameSlot) nameSlot.textContent = ', ' + fn;
      sessionStorage.removeItem('bellori_contact_name');
    } catch (e) {}
    confirm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return; // pas de formulaire sur cet écran
  }

  var form = root.querySelector('#contact-form');
  if (!form) return;
  var motifInput = form.querySelector('[data-motif-input]');
  var subjectInput = form.querySelector('[data-subject-input]');
  var orderFields = form.querySelector('[data-order-fields]');
  var hp = form.querySelector('[data-hp]');

  /* ---- Pills de motif ---- */
  form.querySelectorAll('.bl-contact__pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      form.querySelectorAll('.bl-contact__pill').forEach(function (p) {
        p.classList.remove('is-on'); p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-on'); pill.setAttribute('aria-pressed', 'true');
      var full = pill.getAttribute('data-full');
      var prefix = pill.getAttribute('data-prefix');
      if (motifInput) motifInput.value = full;
      if (subjectInput) subjectInput.value = '[' + prefix + '] Message depuis le site';
      if (orderFields) orderFields.hidden = pill.getAttribute('data-orderfields') !== 'true';
    });
  });

  /* ---- Pré-remplissage via ?motif= (liens depuis Livraison & retours, panier, e-mails) ---- */
  try {
    var qp = new URLSearchParams(window.location.search);
    var motif = (qp.get('motif') || '').toLowerCase();
    if (motif) {
      var map = { retour: 'livraison', echange: 'livraison', livraison: 'livraison', suivi: 'commande', colis: 'commande', commande: 'commande', garantie: 'installation', installation: 'installation', conseil: 'conseil', pro: 'pro', autre: 'autre' };
      var starters = {
        retour: 'Demande de retour — n° de commande : \nMiroir concerné : \n',
        echange: 'Demande d’échange de taille — n° de commande : \nTaille actuelle :  → taille souhaitée : \n',
        garantie: 'Problème sous garantie — n° de commande : \nDescription du souci (photo ou vidéo jointe si possible) : \n',
        suivi: 'Où en est mon colis ? — n° de commande : \n'
      };
      var target = form.querySelector('.bl-contact__pill[data-motif="' + (map[motif] || 'autre') + '"]');
      if (target) target.click();
      var body = form.querySelector('[name="contact[body]"]');
      if (body && !body.value && starters[motif]) body.value = starters[motif];
      // Contexte joint par le bouton « Une question ? » (produit / panier / quiz) sans Shopify Inbox
      var ctx = qp.get('ctx');
      if (body && ctx) { body.value = (body.value ? body.value.replace(/\s+$/, '') + '\n\n' : '') + ctx + '\n\n'; body.focus(); }
      if (subjectInput && starters[motif]) {
        var lbl = { retour: 'Retour', echange: 'Échange', garantie: 'Garantie', suivi: 'Suivi de colis' }[motif];
        if (lbl) subjectInput.value = '[' + lbl + '] Message depuis le site';
      }
    }
  } catch (e) {}

  /* ---- Copier l'e-mail ---- */
  root.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = btn.getAttribute('data-copy');
      var done = function () { var t = btn.textContent; btn.textContent = 'Copié'; setTimeout(function () { btn.textContent = t; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(val).then(done, done);
      } else {
        var ta = document.createElement('textarea'); ta.value = val; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta); done();
      }
    });
  });

  /* ---- Soumission : honeypot + mémoriser le prénom ---- */
  form.addEventListener('submit', function (e) {
    if (hp && hp.value) { e.preventDefault(); return; }
    var nameField = form.querySelector('[name="contact[name]"]');
    if (nameField && nameField.value) {
      try { sessionStorage.setItem('bellori_contact_name', nameField.value.trim().split(' ')[0]); } catch (err) {}
    }
  });
})();
